import React from "react";
import { GoTrash } from "react-icons/go";

const PaymentsEntryTableQuotation = ({ styles, paymentTypes, setValue }) => {
 console.log(paymentTypes)
  return (
    <>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Sr No</th>
            <th>Mode</th>
            <th>Amount</th>
            <th>Gold</th>
            <th>Silver</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {!paymentTypes?.length ? (

          <tr ><td colSpan={6} style={{color:"gray"}}>No Payments Added</td></tr>
          ):(
            <>
            {console.log(paymentTypes)}
          {paymentTypes?.map((row, index) => (
            <tr key={row.id}>
              <td>{index + 1}</td>
              <td>{row.mode}</td>
              <td>{+(row?.amount || 0) || +(row?.MetalCashTotalAmount || 0)}</td>
              <td>
                {(row?.mode == "Metal" ||
                  row?.mode == "Metal to Cash" ||
                  row?.mode == "Cash to Metal") &&
                (row?.MetalType == "Gold" ||
                  row?.MetalType == "Pure Gold" ||
                  row?.MetalType == "Old Gold") &&
                +row?.MetalFinePaid
                  ? (+row?.MetalFinePaid)?.toFixed(3)
                  : ""}
              </td>
              <td>
                {(row?.mode == "Metal" ||
                  row?.mode == "Metal to Cash" ||
                  row?.mode == "Cash to Metal") &&
                (row?.MetalType == "Silver" ||
                  row?.MetalType == "Pure Silver" ||
                  row?.MetalType == "Old Silver") &&
                +row?.MetalFinePaid
                  ? (+row?.MetalFinePaid)?.toFixed(3)
                  : ""}
              </td>
              <td>
                <GoTrash
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setValue(
                      "paymentTypes",
                      paymentTypes.filter((_, i) => i !== index) // Remove by index
                    );
                  }}
                  size={24}
                />
              </td>
            </tr>
          ))}
          </>
        ) }
        </tbody>
      </table>
    </>
  );
};

export default PaymentsEntryTableQuotation;
